
<template>
    <div>
        <md-card class="card_full_screen">
            <md-card-content>
                <ValidationObserver ref="valObserver">
                    <form>
                        <FadeTransition :duration="400" mode="out-in" v-if="!loading">
                            <div class="md-layout md-alignment-top-left">

                                <div class="md-layout-item md-size-100 md-small-size-100 md-medium-size-100 md-xlarge-size-100">
                                    <div class="title_with_btns">
                                        <div class="titles">
                                            <h3 class="zero_b_margin">{{website.name}}</h3>
                                            <p class="vertically_tight">{{website.address}}</p>
                                        </div>
                                        <website-menu></website-menu>


                                        <div class="btns">
                                            <div class="btns_sxs">

                                                <md-button class="md-primary" @click="save" title="Attempt to save all changes">Save All</md-button>
                                            </div>



                                        </div>


                                    </div>

                                    <div class="md-layout md-size-25">
                                        <md-switch v-model="hideNonChosen">Hide Non Chosen</md-switch>
                                        <p>{{numberChosen}} Chosen, {{numberSelected}} Selected</p>
                                    </div>

                                </div>


                                <div class="md-layout-item md-size-80">
                                    <div v-for="group in website.amenities.groups" :key="group.name"
                                         class="amenity_group">
                                        <h4 class="card-title amentity_group_title">{{ group.name }}</h4>
                                        <div v-for="amenity in group.items" :key="amenity.name" class="md-layout amenity_row" :class="amentityRowClass(amenity.id)" v-show="hideNonChosen? amenity.chosen : true">
                                            <md-switch v-model="amenity.selected" class="md-layout-item md-size-20">{{ amenity.name }}</md-switch>
                                            <md-switch v-model="amenity.chosen" class="md-layout-item md-size-5"></md-switch>
                                             <div class="md-layout-item md-size-50">
                                                 <component v-if="amenity.chosen" v-bind:is="amenity.component" :amenity="amenity"></component>
                                             </div>
                                            <div class="md-layout-item md-size-5 icon_cell">
                                                <a v-once @click="getAmenity(amenity)"
                                                   :class="{ disabled : (!amenity.selected) }"
                                                   title="Preview this amenity (with data from server)" class="icon_link"><i class="fas fa-caret-right"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="fixed_preview circle_icon" v-html="amenityPreview">
                                </div>


                            </div>
                        </FadeTransition>
                        <div class="loader_wrap" v-if="loading">
                            <loader></loader>
                        </div>
                    </form>
                </ValidationObserver>
            </md-card-content>
        </md-card>
    </div>
</template>
<script>
    import { FadeTransition, ZoomCenterTransition } from "vue2-transitions";
    import Loader from "@/components/Loader.vue";

    import Help from "@/ts/Help";
    import NotyTypes from "@/ts/NotyTypes";
    import Api from '@/ts/UvApiService';

    import WebsiteMenu from "./WebsiteMenu.vue";


    import AmenityText from "@/pages/Dashboard/Buildings/Amenities/AmenityText.vue";
    import AmenityRadio from "@/pages/Dashboard/Buildings/Amenities/AmenityRadio.vue";
    import AmenityCheckbox from "@/pages/Dashboard/Buildings/Amenities/AmenityCheckbox.vue";
    import AmenityNumber from "@/pages/Dashboard/Buildings/Amenities/AmenityNumber.vue";
    import AmenityChips from "@/pages/Dashboard/Buildings/Amenities/AmenityChips.vue";
    import AmenityRadioText from "@/pages/Dashboard/Buildings/Amenities/AmenityRadioText.vue";
    import AmenityRadioTextTextText from "@/pages/Dashboard/Buildings/Amenities/AmenityRadioTextTextText.vue";
    import AmenityCheckboxText from "@/pages/Dashboard/Buildings/Amenities/AmenityCheckboxText.vue";
    import AmenityNumberText from "@/pages/Dashboard/Buildings/Amenities/AmenityNumberText.vue";
    import AmenityChipsText from "@/pages/Dashboard/Buildings/Amenities/AmenityChipsText.vue";
    import AmenityRadioNumberText from "@/pages/Dashboard/Buildings/Amenities/AmenityRadioNumberText.vue";
    import AmenityRadioChipsText from "@/pages/Dashboard/Buildings/Amenities/AmenityRadioChipsText.vue";
    import AmenityCheckboxRadioText from "@/pages/Dashboard/Buildings/Amenities/AmenityCheckboxRadioText.vue";


    export default {
        components: {
            Loader
            , FadeTransition
            //, ZoomCenterTransition
            //, BuildingVisitorProcess
            //, CircleIcon
            , WebsiteMenu
        //Amenity com types
            , AmenityText
            , AmenityRadio
            , AmenityCheckbox
            , AmenityNumber
            , AmenityChips
            , AmenityRadioText
            , AmenityRadioTextTextText
            , AmenityCheckboxText
            , AmenityNumberText
            , AmenityChipsText
            , AmenityRadioNumberText
            , AmenityRadioChipsText
            , AmenityCheckboxRadioText
        },
        data() {
            return {
                loading: true,
                website: null,
                amenityPreview: null,
                amenityIdCurrentlyInPreview: null,
                hideNonChosen: false
            }
        },
        computed: {
            numberChosen() {
                var allAmenities = Help.flatten(this.website.amenities.groups.map(ag => ag.items));
                return allAmenities.filter(a => a.chosen).length;
            },
            numberSelected() {
                var allAmenities = Help.flatten(this.website.amenities.groups.map(ag => ag.items));
                return allAmenities.filter(a => a.selected).length;
            }
        },
        methods: {
            amentityRowClass(amentiyId) {
                return Help.isNullOrUndef(this.amenityIdCurrentlyInPreview) ? "" : (this.amenityIdCurrentlyInPreview == amentiyId)? "in-preview" : "";
            },
            async getAmenity(amenity) {
                this.amenityPreview = null;
                this.amenityIdCurrentlyInPreview = null;
                try {
                    this.amenityPreview = await Api.websites.getWebsiteAmenity(this.website.id, amenity.id);
                    this.amenityIdCurrentlyInPreview = amenity.id;
                }
                catch (error) {
                    alert("Failed to get amenity - it must be saved as selected first : " + error);
                }
            },
            async fetchData() {
                if (!Help.isNullOrUndef(this.$route.params.buildingId)) {
                    if (Help.isNullOrUndef(this.website)) {
                        var res = await Api.websites.getWebsiteAmenities(this.$route.params.buildingId);
                        this.website = res;
                    }
                    this.loading = false;
                }
            },
            async save() {
                this.$refs.valObserver.validate().then(async success => {
                    if (!success) {
                        setTimeout(() => {
                            this.notifyErrors(Object.values(this.$refs.valObserver.errors));
                        }, 100);
                        return;
                    }
                    else {
                        await this.saveRaw();
                        //this.$router.push(this.nextUrl);
                    }
                });
            },
            async saveRaw() {
                var res = await Api.websites.upsertAmenities(this.website);
                if (res.success === true) {
                    alert("that worked");
                }
                else {
                    this.showServerFailMessage(res, "saving all");
                }
            },
            notifyErrors(errorsArray) {
                var errorsLis = "";
                errorsArray.forEach((e) => {
                    if (e.length > 0) {
                        e.flat().forEach((ei) => {
                            errorsLis += `<li>${Help.removeFullStop(ei)}</li>`;
                        });
                    }
                });
                this.$notify({
                    timeout: 10000,
                    message: `Please <b>fix all errors</b> on the current page <b>to proceed</b><ul>${errorsLis}</ul>`,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            },
            showServerFailMessage(res, action) {
                var msg = res.message ?? `Unknown problem on the server ${action} this building`;
                this.$notify({
                    timeout: 10000,
                    message: msg,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            }
        },
        async mounted() {
            await this.fetchData();
        },

    }
</script>
<style lang="scss">

    .md-switch.md-disabled .md-switch-container {
        background-color: rgba(80, 80, 80, 0.1) !important;
    }

    .icon_cell {
        padding-top: 16px;
    }

        .icon_cell .disabled {
            background-color: rgba(80, 80, 80, 0.1) !important;
            pointer-events: none;
            opacity: 0.6;
        }

    .fixed_preview {
        max-width: 25%;
        max-width: 255px;
        position: fixed;
        right: 40px;
        top: 200px;
    }

    .amenity_group {
        border-bottom: solid 1px rgba(0,0,0,0.2);
        margin-bottom: 10rem;
    }

    .amenity_row {
        border-bottom: solid 1px rgba(208, 186, 186, 0.10);
        padding-top: 2rem;
        padding-bottom: 4rem;
    }

        .amenity_row.in-preview {
            background-color: #eae0e0; 
        }
</style>